<template>

  <div class="bg-white rounded-sm mx-2 my-3">
    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
          <span class="title">Non Individual Registry</span>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <NirRegistryBreakdown/>
      </b-col>
    </b-row>
  </div>
</template>


<script>

import {mapActions, mapGetters} from "vuex"
import moment from "moment";
import router from "@/router";
import NirRegistryBreakdown from "./NirRegistryBreakdown.vue";

export default {
  name: "NonIndividualRegistry",
  components: {NirRegistryBreakdown},
  data(){
    return{
      loading:false,
      currentPage:1,
      limit:15,
      entities:[],
      pagination:{
        totalElements: 0,
        totalPages:0
      },
      rows:{
        odd:"border-t border-grey hover:bg-header_grey",
        even:"border-t border-grey bg-header_grey"
      },
      search:"",
      subType:null,
      startDate:null,
      endDate:null,
      startRegistrationDate:null,
      endRegistrationDate:null,
      status:null,
      hasError:false,
      errorMessage:null
    }
  },
  mounted() {
    this.fetch()
  },
  methods:{
    ...mapActions(["fetchCompanyRegistry"]),
    fetch(){
      let data = {
        search:this.search,
        subType:this.subType,
        startDate:this.dateRangeFormat(this.startDate),
        endDate:this.dateRangeFormat(this.endDate),
        startRegistrationDate: this.startRegistrationDate ? moment(this.startRegistrationDate).format('YYYY-MM-DD') : null,
        endRegistrationDate: this.endRegistrationDate ? moment(this.endRegistrationDate).format('YYYY-MM-DD') : null,
        status:this.status,
        page:this.currentPage,
        limit:this.limit,
      }
      this.loading = true
      this.hasError = false
      this.fetchCompanyRegistry(data)
    },
    next(){
      if(this.currentPage < this.pagination.totalPages){
        this.currentPage++
        this.fetch()
      }
    },
    previous(){
      if(this.currentPage > 1){
        this.currentPage--
        this.fetch()
      }else{
        this.warningToast("Observation", "No more data to show")
      }
    },
    getStatusStyling(status){
      if(status === "Registered" || status === "Amalgamated" || status === "Compliant"){
        return "text-green"
      }else if(status === "In_Liquidation"){
        return "text-green"
      }else{
        return "text-red"
      }
    },
    viewFile(data){
      if(data.status === "WALID"){
        this.errorToast("Error", "No results found")
      } else {
        data.type = "company"
        data.subType = data.subEntityType
        localStorage.setItem("registryEntity", JSON.stringify(data))
        router.push("/home/registry/business/file-viewer/" + data.brn)
        router.go(0)
      }


    },
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    cleanEntityType(name){
      let n = name.replaceAll("-", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
  },
  computed:{
    ...mapGetters(["getCompanyRegistry", "getRegistryError"])
  },
  watch:{
    getCompanyRegistry(data){
      this.loading = false
      this.entities = data.content
      this.pagination = {
        totalPages:data.totalPages,
        totalElements:data.totalElements
      }
    },
    getRegistryError(data){
      this.loading = false
      this.hasError = true
      this.errorMessage = data.message
    }
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/table.css";

.verified{
  @apply text-xs font-bold;
  color: green;
  font-style: italic;
}

.unverified{
  @apply text-xs font-bold;
  color: #b80404;
  font-style: italic;
}

.assign-btn{
  @apply px-3 py-1 bg-white border-2 font-bold border-green text-green text-xs w-full;
}

.assign-btn:hover{
  @apply bg-green text-white;
}

.de-assign-btn{
  @apply px-3 py-1 bg-white border-2 border-red text-red font-bold text-xs w-full;
}

.de-assign-btn:hover{
  @apply bg-red text-white;
}

.paginate-details{
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn{
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover{
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn{
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>